<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="mapping-code-selector"
    :width="isDepartment ? '800px' : '600px'"
  >
    <div class="app-main-inner-row">
      <el-form :inline="true" label-position="left" @submit.native.prevent>
        <el-form-item v-if="isDepartment" :label="$t('CargoMsg.Cargo_BranchCMP')" class="el-form-item-filter">
          <el-tooltip :content="isZh?$store.getters.currentOffice.chineseName:$store.getters.currentOffice.englishName" placement="bottom">
            <div class="company-select" @mousemove="handleCompanyMousemove">
              <el-select
                v-if="$store.getters.userInfo.groupCompany"
                ref="companySelect"
                v-model="currentOfficeId"
                class="navbar-company-selector"
                popper-class="navbar-company-selector-popper"
                filterable
                @change="handleCompany"
              >
                <el-tooltip
                  v-for="office in currentOfficeList"
                  :key="office.uuid"
                  :content="isZh?office.chineseName:office.englishName"
                  placement="left"
                >
                  <el-option
                    :value="office.officeId"
                    :label="office.code"
                  />
                </el-tooltip>
              </el-select>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item :label="lbType" class="el-form-item-filter">
          <el-input v-model="txtFilter" @input="filterChangeHandler" @keyup.enter.native="filterChangeHandler" />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        min-height="320px"
      />
    </div>
    <span slot="footer">
      <el-button type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as CompanyConstants from '@/class/cargo/model/parameters/CompanyConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { cacheKeys, getFilterCacheList, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { User } from '@/class/model/sys/User'
import { getDepartmentByOfficeId } from '@/api/user'
import { queryInvoiceTitles } from '@/api/partner/title'
import { getUserInfo } from '@/utils/auth'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'

export default {
  name: 'MappingCodeSelector',
  props: {
    visible: { type: Boolean, required: true },
    accountSet: { type: Object, required: true },
    codeType: { type: Number, required: true },
    codeMappingType: { type: Number, required: true },
    existsMap: { type: Map },
    existsPartnerMap: { type: Map }
  },
  data() {
    return {
      innerVisible: false,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      rowData: [],
      sourceRowData: [],
      lbType: '',
      txtFilter: '',
      title: '',
      filterFunction: null,
      customColumnDefs: [],
      companyList: [],
      currencys: [],
      users: [],
      departments: [],
      isExt: false,
      currentOfficeId: this.$store.getters.currentOfficeId,
      titles: [] // 应收开票抬头
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isDepartment() { // 判断是否是部门编码以及集团公司
      return this.codeType === FinanceInterfaceConstants.MAPPING_DEPARTMENT.code && this.$store.getters.isGroupCompany
    },
    columnDefs() {
      return this.customColumnDefs
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.currentOfficeId = this.$store.getters.currentOfficeId
        this.txtFilter = ''
        this.codeTypeChanged()
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isExt = Number(cache.config.get('ext')) === 1
  },
  methods: {
    // 过滤选项
    salesFilter(user) {
      const typedText = this.txtFilter.trim().toLowerCase()
      if (user.chineseName && user.chineseName.toLowerCase().search(typedText) > -1) {
        return true
      }
      if (user.englishName && user.englishName.toLowerCase().search(typedText) > -1) {
        return true
      }
      if (user.login.toLowerCase().search(typedText) > -1) {
        return true
      }
      return false
    },
    // 进行字符过滤
    companyFilter(company) {
      if (!this.txtFilter || this.txtFilter.trim() === '') {
        return true
      }
      const typedText = this.txtFilter.trim()
      if (company.cnShortName && company.cnShortName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      if (company.shortName && company.shortName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      if (company.chineseName && company.chineseName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      if (company.englishName && company.englishName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    // 进行字符过滤
    departmentFilter(department) {
      const typedText = this.txtFilter.trim()
      if (department.chineseName && department.chineseName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      if (department.englishName && department.englishName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    // 进行字符过滤
    currencyFilter(currency) {
      const typedText = this.txtFilter.trim()
      if (currency.code && currency.code.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      if (currency.name && currency.name.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    invoiceTitleFilter(title) {
      const typedText = this.txtFilter.trim()
      if (title.name && title.name.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    collectionPaymentMethodFilter(type) {
      const typedText = this.txtFilter.trim()
      if (type.chineseName && type.chineseName.toLowerCase().indexOf(typedText.toLowerCase()) >= 0) {
        return true
      }
      return false
    },
    // 文本变更时过滤显示
    filterChangeHandler() {
      this.filterFunction = null
      switch (this.codeType) {
        case FinanceInterfaceConstants.MAPPING_PARTNER.code :
        case FinanceInterfaceConstants.MAPPING_INTERNAL.code :
          this.filterFunction = this.companyFilter
          break
        case FinanceInterfaceConstants.MAPPING_DEPARTMENT.code :
          this.filterFunction = this.departmentFilter
          break
        case FinanceInterfaceConstants.MAPPING_SALES.code :
        case FinanceInterfaceConstants.MAPPING_STAFF.code :
          this.filterFunction = this.salesFilter
          break
        case FinanceInterfaceConstants.MAPPING_CURRENCY.code :
          this.filterFunction = this.currencyFilter
          break
        case FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code :
        case FinanceInterfaceConstants.MAPPING_SE.code :
        case FinanceInterfaceConstants.MAPPING_SI.code :
        case FinanceInterfaceConstants.MAPPING_AE.code :
        case FinanceInterfaceConstants.MAPPING_AI.code :
        case FinanceInterfaceConstants.MAPPING_BUSINESS_TYPE.code :
          break
        case FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code :
          this.filterFunction = this.invoiceTitleFilter
          break
        case FinanceInterfaceConstants.MAPPING_RECEIPT_OR_PAYMENT.code :
          this.filterFunction = this.collectionPaymentMethodFilter
          break
        default : break
      }
      // 过滤rowData
      if (this.filterFunction) {
        this.rowData = this.sourceRowData.filter(row => this.filterFunction(row))
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 确认
    confirmHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const list = []
      for (const row of rows) {
        const mapping = {}
        mapping.businessDataType = 0
        mapping.entryType = 0
        mapping.priority = 0
        mapping.valueType1 = false
        mapping.financeCode = ''
        mapping.accountTitle = ''
        mapping.baseDataType = this.codeType
        mapping.codeMappingType = this.codeMappingType
        switch (this.codeType) {
          case FinanceInterfaceConstants.MAPPING_PARTNER.code :
            mapping.baseDataValue = String(row.cmpIdx)
            break
          case FinanceInterfaceConstants.MAPPING_INTERNAL.code :
            mapping.baseDataValue = String(row.cmpIdx)
            mapping.financeCode = '1'
            break
          case FinanceInterfaceConstants.MAPPING_DEPARTMENT.code :
            mapping.baseDataValue = String(row.departmentId)
            break
          case FinanceInterfaceConstants.MAPPING_SALES.code :
          case FinanceInterfaceConstants.MAPPING_STAFF.code :
            mapping.baseDataValue = String(row.userId)
            break
          case FinanceInterfaceConstants.MAPPING_CURRENCY.code :
            mapping.baseDataValue = row.code
            break
          case FinanceInterfaceConstants.MAPPING_PREFIX.code :
            mapping.baseDataValue = row.code
            break
          case FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code :
          case FinanceInterfaceConstants.MAPPING_SE.code :
          case FinanceInterfaceConstants.MAPPING_SI.code :
          case FinanceInterfaceConstants.MAPPING_AE.code :
          case FinanceInterfaceConstants.MAPPING_AI.code :
            mapping.baseDataValue = row.code
            break
          case FinanceInterfaceConstants.MAPPING_BUSINESS_TYPE.code :
            mapping.baseDataValue = row.code
            break
          case FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code :
            mapping.baseDataValue = row.name
            break
          case FinanceInterfaceConstants.MAPPING_RECEIPT_OR_PAYMENT.code :
            mapping.baseDataValue = row.code
            break
          default : break
        }
        list.push(mapping)
      }
      this.$emit('enter', list)
      this.innerVisible = false
    },
    cancelHandler() {
      this.innerVisible = false
    },
    // 根据codeType显示对应对话框标题、过滤条件标题、列定义
    async codeTypeChanged() {
      let dataSource = []
      let column1
      let column2
      let column3
      let columnArr = []
      this.customColumnDefs = [{
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      }]
      switch (this.codeType) {
        case FinanceInterfaceConstants.MAPPING_PARTNER.code :
          dataSource = getFilterCacheList(basicCacheKeys.basic_data_Company, (item) => {
            return (item.branchId === 1 || item.branchId === this.accountSet.branchId || (item.multipleBranchId && item.multipleBranchId.split(',').includes(String(this.accountSet.branchId)))) &&
              !this.existsPartnerMap.has(this.codeType + '-' + this.codeMappingType + '-' + item.cmpIdx)
          })
          this.lbType = this.$t('CargoMsg.Cargo_Parter')
          column1 = this.getColumnDef('shortName', this.$t('CargoMsg.Cargo_Abbreviation'))
          column2 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_Name'))
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_INTERNAL.code :
          dataSource = getFilterCacheList(basicCacheKeys.basic_data_Company, (item) => {
            return (item.branchId === 1 || item.branchId === this.accountSet.branchId) && !this.existsMap.has(this.codeType + '-' + item.cmpIdx)
          })
          this.lbType = this.$t('CargoMsg.Cargo_Parter')
          column1 = this.getColumnDef('shortName', this.$t('CargoMsg.Cargo_Abbreviation'))
          column2 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_Name'))
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_DEPARTMENT.code :
          if (!this.departments || this.departments.length === 0) {
            this.departments = await getDepartmentByOfficeId(this.$store.getters.currentOfficeId).then(res => res.data)
          }
          this.filterDataSource(dataSource, this.departments)
          this.lbType = this.$t('CargoMsg.Cargo_DepartmentP')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_ChineseName'))
          column2 = this.getColumnDef('englishName', this.$t('CargoMsg.Cargo_EnglishName'))
          columnArr = [column1, column2]
          if (this.isDepartment) {
            column3 = this.getColumnDef('officeName', this.$t('CargoMsg.Cargo_BranchCMP'))
            columnArr.push(column3)
          }
          this.customColumnDefs.push(...columnArr)
          break

        case FinanceInterfaceConstants.MAPPING_SALES.code :
          this.users = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId, true)
          await this.addUsers(dataSource, FinanceInterfaceConstants.MAPPING_SALES.code)
          this.lbType = this.$t('CargoMsg.Cargo_SalesPerson')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_ChineseName'))
          column2 = this.getColumnDef('englishName', this.$t('CargoMsg.Cargo_EnglishName'))
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_CURRENCY.code :
          if (!this.currencys || this.currencys.length === 0) {
            this.currencys = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
          }
          for (const currency of this.currencys) {
            if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_CURRENCY.code + '-' + currency.code)) {
              dataSource.push(currency)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_Currency')
          column1 = this.getColumnDef('code', this.$t('CargoMsg.Cargo_Code'))
          column2 = this.getColumnDef('name', this.$t('CargoMsg.Cargo_Name'))
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_PREFIX.code :
          if (!this.accountSet.accountingDocumentType || this.accountSet.accountingDocumentType.length === 0) {
            this.accountSet.accountingDocumentType = this.accountSet.accountingDocumentType // await accountingDocumentTypeApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
          }
          for (const documentType of this.accountSet.accountingDocumentType) {
            if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_PREFIX.code + '-' + documentType.code)) {
              dataSource.push(documentType)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_VoucherLetter')
          column1 = this.getColumnDef('name', this.$t('CargoMsg.Cargo_Name'))
          column2 = this.getColumnDef('prefix', this.$t('CargoMsg.Cargo_Letter'))
          this.customColumnDefs.push(...[column1, column2])
          break
        case FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code :
          for (const state of Array.from(FinanceInterfaceConstants.ENTRY_TYPES)) {
            if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code + '-' + state.code)) {
              dataSource.push(state)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_JournalEntryCategory')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_JournalEntryCategory'))
          column2 = this.getColumnDef('', '')
          this.customColumnDefs.push(...[column1, column2])
          break
        case FinanceInterfaceConstants.MAPPING_SE.code :
        case FinanceInterfaceConstants.MAPPING_SI.code :
        case FinanceInterfaceConstants.MAPPING_AE.code :
        case FinanceInterfaceConstants.MAPPING_AI.code :
          for (const prop of CompanyConstants.PROPERTIES) {
            if (!this.existsMap.has(this.codeType + '-' + prop.code)) {
              dataSource.push(prop)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_CategoryOfPartner')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_Property'))
          column2 = this.getColumnDef('', '')
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_BUSINESS_TYPE.code :
          for (const lob of Array.from(SystemConstants.FBA_LOBS)) { // CARGO-47003，海风：FBA业务无法生成凭证
            if (!this.existsMap.has(this.codeType + '-' + lob.code)) {
              dataSource.push(lob)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_BusinessType')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_Type'))
          column2 = this.getColumnDef('', '')
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_STAFF.code :
          this.users = await User.getAllUsersByOffice(this.$store.getters.currentOfficeId)
          await this.addUsers(dataSource, FinanceInterfaceConstants.MAPPING_STAFF.code)
          this.lbType = this.$t('CargoMsg.Cargo_Staff')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_ChineseName'))
          column2 = this.getColumnDef('englishName', this.$t('CargoMsg.Cargo_EnglishName'))
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code :
          if (!this.titles || this.titles.length === 0) {
            this.titles = await queryInvoiceTitles({ accountSetUuid: this.accountSet.uuid, branchId: this.accountSet.branchId }).then(res => res.data)
          }
          for (const title of this.titles) {
            if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_INVOICE_TITLE.code + '-' + title.name)) {
              dataSource.push(title)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_InvoiceTitle')
          column1 = this.getColumnDef('name', this.$t('CargoMsg.Cargo_InvoiceTitle'))
          column2 = this.getColumnDef('', '')
          this.customColumnDefs.push(...[column1, column2])
          break

        case FinanceInterfaceConstants.MAPPING_RECEIPT_OR_PAYMENT.code :
          for (const item of Array.from(ClearingConstants.AMOUNT_RECEIVE_TYPES)) {
            if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_RECEIPT_OR_PAYMENT.code + '-' + item.code)) {
              dataSource.push(item)
            }
          }
          this.lbType = this.$t('CargoMsg.Cargo_CollectionPaymentMethod')
          column1 = this.getColumnDef('chineseName', this.$t('CargoMsg.Cargo_Type'))
          column2 = this.getColumnDef('', '')
          this.customColumnDefs.push(...[column1, column2])
          break

        default : break
      }
      this.$nextTick(() => {
        for (const customColumnDef of this.customColumnDefs) {
          this.gridOptions.columnApi.setColumnVisible(customColumnDef.field, true)
        }
      })
      this.rowData = dataSource
      this.sourceRowData = dataSource
      this.title = this.$t('CargoMsg.Cargo_Select') + this.lbType
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ force: true })
        this.gridOptions.api.clearFocusedCell()
      }
    },
    getColumnDef(field, headerName) {
      return {
        headerName: headerName,
        field: field,
        suppressMenu: true,
        width: 250
      }
    },
    async addUsers(dataSource, mappingType) {
      // if (!this.users || this.users.length === 0) {
      //   this.users = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId, true)
      // }
      for (const user of this.users) {
        if (!this.existsMap.has(mappingType + '-' + user.userId)) {
          dataSource.push(user)
        }
      }
    },
    // 切换分公司的时候需要控制部门显示
    handleCompany() {
      let currentDeptList = []
      if (this.currentOfficeId && Number(this.currentOfficeId) === 1) { // 总部的话取所有部门
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department_All, null) || []
      } else {
        const currentOffice = this.currentOfficeList.find(item => Number(item.officeId) === Number(this.currentOfficeId))
        currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
          return item.officeUuid === currentOffice.uuid
        }) || []
      }
      const dataSource = []
      this.filterDataSource(dataSource, currentDeptList)
      this.rowData = dataSource
      this.sourceRowData = dataSource
      this.gridOptions.api.refreshCells({ force: true })
      this.gridOptions.api.clearFocusedCell()
    },
    // 过滤分公司及初始化数据
    filterDataSource(dataSource, currentDeptList) {
      const map = new Map()
      const field = this.isZh ? 'chineseName' : 'englishName'
      for (const office of this.currentOfficeList) {
        map.set(office.uuid, office[field])
      }
      // if (this.isExt) {
      //   for (const department of currentDeptList) {
      //     department.officeName = map.get(department.officeUuid)
      //     dataSource.push(department)
      //   }
      // } else {
      for (const department of currentDeptList) {
        if (!this.existsMap.has(FinanceInterfaceConstants.MAPPING_DEPARTMENT.code + '-' + department.departmentId)) {
          department.officeName = map.get(department.officeUuid)
          dataSource.push(department)
        }
      }
      // }
    },
    // 鼠标悬浮分公司的时候需要显示
    handleCompanyMousemove() {
      this.currentOfficeList.map(eve => {
        if (eve.officeId === this.currentOfficeId) {
          this.$refs.companySelect.$children[0].$el.children[0].title = this.isZh ? eve.chineseName : eve.englishName
        }
      })
    }
  }
}
</script>

<style lang="scss">
.mapping-code-selector {
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-form-item-filter {
    //width: 280px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      //width: 70px !important;
      text-align: center;
      margin-right: 5px;
    }
    .el-form-item__content {
      width: 210px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
}
</style>
